import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '@material-ui/core';
import Zonas from './Zonas';
import { ZonaService } from '../../../services/ZonaService';

const ZonasIndex = () => {
    const history = useHistory();

    const handleDownloadExcel = async () => {
        const resp = await ZonaService.descargarReporte();
        if (resp && !resp.error) {
            const blob = new Blob([resp], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
            const a = document.createElement('a');
            const url = URL.createObjectURL(blob);
            a.style.display = 'none';
            a.href = url;
            a.download = 'reporte.xlsx';
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
        }
    };
    return (
        <div className="w-full p-4 md:p-6">
            <div className="flex justify-between items-center mb-6">
                <h1 className="text-2xl font-bold text-gray-900 tracking-tight">Zonas</h1>
                <div className="flex space-x-2">
                    <Button
                        variant="contained"
                        onClick={handleDownloadExcel}
                    >
                        Descargar Excel
                    </Button>
                    <Button
                        className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-full shadow-md"
                        variant="contained"
                        color="primary"
                        onClick={() => history.push(`/Catalogo/Zona`)}
                    >
                        + Nuevo Zona
                    </Button>
                </div>
            </div>

            <Zonas />
        </div>
    );
};

export default ZonasIndex;
